import React, { useState, useEffect } from "react";
import ajax from "superagent";

export type Photographer = {
  id: number;
  slug: string;
  name: string;
  albumsCount: number;
  photosCount: number;
  profilePicture: string | null;
  browsePhotographersPath: string;
};

type Hook = (photographer: string | null) => {
  photographers: Photographer[];
  loading: boolean;
  error: string;
};

const useFilteredPhotographers: Hook = photographer => {
  const [loading, setLoading] = useState(true);
  const [photographers, setPhotographers] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    if (photographer)
      ajax
        .get("api/v1/search_photographers/name")
        .query({
          q: photographer
        })
        .then(response => {
          setLoading(false);
          setPhotographers(response.body.users);
        })
        .catch(err => {
          setLoading(false);
          setError(err.message);
        });
  }, [photographer]);

  return {
    error,
    loading,
    photographers
  };
};

export default useFilteredPhotographers;
